export default __webpack_public_path__ + "static/media/target.c054aa6c.svg";